import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  BulkChangeClaimStatusInput,
  BulkUpdateFlexiReimbursementClaimsStatusResponse,
} from 'api/gql-utils/flexibleBenefits/types';

const bulkUpdateFlexiReimbursementClaimsStatusMutation = gql`
  mutation PayrollFlexiReimbursementClaimsBulkApproveOrReject($input: BulkChangeClaimStatusInput!) {
    payrollFlexiReimbursementClaimsBulkApproveOrReject(input: $input) {
      code
      success
      message
      claims {
        claim_id
        tenant_id
        merchant_id
        component_id
        assignment_id
        expense_date
        employee_id
        employee_name
        claim_amount
        approved_amount
        claim_description
        claim_evidence_id
        claim_status
        claim_comments
        last_modified_by
        created_at
        updated_at
        component_display_name
      }
    }
  }
`;

export const bulkUpdateFlexiReimbursementClaimsStatus = (input: BulkChangeClaimStatusInput) => {
  return graphQLApi<BulkUpdateFlexiReimbursementClaimsStatusResponse, { input: BulkChangeClaimStatusInput }>({
    query: bulkUpdateFlexiReimbursementClaimsStatusMutation,
    queryVariables: { input },
  });
};
